import {
  FETCH_METERS, FETCH_METERS_SUCCESS, FETCH_METERS_FAIL,
  FETCH_METER, FETCH_METER_SUCCESS, FETCH_METER_FAIL,
  CREATE_METER, CREATE_METER_SUCCESS, CREATE_METER_FAIL,
  UPDATE_METER, UPDATE_METER_SUCCESS, UPDATE_METER_FAIL,
  DELETE_METER, DELETE_METER_SUCCESS, DELETE_METER_FAIL,
  FETCH_METERS_BY_ASSET, FETCH_METERS_BY_ASSET_SUCCESS, FETCH_METERS_BY_ASSET_FAIL,
  FETCH_METER_READINGS, FETCH_METER_READINGS_SUCCESS, FETCH_METER_READINGS_FAIL,
  CREATE_METER_READING, CREATE_METER_READING_SUCCESS, CREATE_METER_READING_FAIL,
  FETCH_READINGS_BY_WORK_ORDER, FETCH_READINGS_BY_WORK_ORDER_SUCCESS, FETCH_READINGS_BY_WORK_ORDER_FAIL,
  CLEAR_METER_MESSAGES,
} from './actionTypes';

const INIT_STATE = {
  meters: [],
  metersLoading: false,
  metersError: null,
  metersPagination: null,

  selectedMeter: null,
  selectedMeterLoading: false,
  selectedMeterError: null,

  assetMeters: [],
  assetMetersLoading: false,

  saving: false,
  saveError: null,
  saveSuccess: null,

  readings: [],
  readingsLoading: false,
  readingsError: null,
  readingsPagination: null,

  woReadings: [],
  woReadingsLoading: false,
};

const Meter = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Meters list
    case FETCH_METERS:
      return { ...state, metersLoading: true, metersError: null };
    case FETCH_METERS_SUCCESS:
      return {
        ...state, metersLoading: false,
        meters: action.payload.content || action.payload,
        metersPagination: action.payload.content ? {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          number: action.payload.number,
          size: action.payload.size,
        } : null,
      };
    case FETCH_METERS_FAIL:
      return { ...state, metersLoading: false, metersError: action.payload };

    // Single meter
    case FETCH_METER:
      return { ...state, selectedMeterLoading: true, selectedMeterError: null };
    case FETCH_METER_SUCCESS:
      return { ...state, selectedMeter: action.payload, selectedMeterLoading: false };
    case FETCH_METER_FAIL:
      return { ...state, selectedMeterLoading: false, selectedMeterError: action.payload };

    // Meters by asset
    case FETCH_METERS_BY_ASSET:
      return { ...state, assetMetersLoading: true };
    case FETCH_METERS_BY_ASSET_SUCCESS:
      return { ...state, assetMeters: action.payload, assetMetersLoading: false };
    case FETCH_METERS_BY_ASSET_FAIL:
      return { ...state, assetMetersLoading: false };

    // Create
    case CREATE_METER:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case CREATE_METER_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'Meter created successfully', meters: [...state.meters, action.payload] };
    case CREATE_METER_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Update
    case UPDATE_METER:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case UPDATE_METER_SUCCESS:
      return {
        ...state, saving: false, saveSuccess: 'Meter updated successfully',
        meters: state.meters.map(m => m.id === action.payload.id ? action.payload : m),
        selectedMeter: action.payload,
      };
    case UPDATE_METER_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Delete
    case DELETE_METER:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case DELETE_METER_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'Meter deleted successfully', meters: state.meters.filter(m => m.id !== action.payload) };
    case DELETE_METER_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Readings
    case FETCH_METER_READINGS:
      return { ...state, readingsLoading: true, readingsError: null };
    case FETCH_METER_READINGS_SUCCESS:
      return {
        ...state, readingsLoading: false,
        readings: action.payload.content || action.payload,
        readingsPagination: action.payload.content ? {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          number: action.payload.number,
          size: action.payload.size,
        } : null,
      };
    case FETCH_METER_READINGS_FAIL:
      return { ...state, readingsLoading: false, readingsError: action.payload };

    // Create reading
    case CREATE_METER_READING:
      return { ...state, saving: true, saveError: null, saveSuccess: null };
    case CREATE_METER_READING_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'Reading recorded successfully', readings: [action.payload, ...state.readings] };
    case CREATE_METER_READING_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // Readings by work order
    case FETCH_READINGS_BY_WORK_ORDER:
      return { ...state, woReadingsLoading: true };
    case FETCH_READINGS_BY_WORK_ORDER_SUCCESS:
      return { ...state, woReadings: action.payload, woReadingsLoading: false };
    case FETCH_READINGS_BY_WORK_ORDER_FAIL:
      return { ...state, woReadingsLoading: false };

    // Clear
    case CLEAR_METER_MESSAGES:
      return { ...state, saveError: null, saveSuccess: null };

    default:
      return state;
  }
};

export default Meter;
